import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../../services/authService";
import imagesService from "../../services/imagesService";
import { Status } from "../../types/status";
import {
  HomeBlock,
  HomeContent,
  HomeImageCount,
  HomeLogoutButton,
  HomeMessage,
  HomeStartButton,
  HomeTitle,
} from "./HomeStyles";

const Home = () => {
  const [uncheckedImagesCount, setUncheckedImagesCount] = useState(0);
  const navigate = useNavigate();

  const fetchAvailableImages = async () => {
    const response = await imagesService.getAvailableImages();

    if (response.status === Status.Success) {
      setUncheckedImagesCount(response.data.counter);
      return;
    }

    if (response.status === Status.AuthError) {
      navigate("/auth");
    }
  };

  useEffect(() => {
    fetchAvailableImages();
  }, []);

  const handleLogout = async () => {
    try {
      const response = await authService.logout();

      if (response.status === Status.Success) {
        navigate("/auth");
      }
    } catch (error) {
      console.error("Ошибка при выходе из системы:", error);
    }
  };

  const handleStartWork = () => navigate("/image");

  const hasUncheckedImages = uncheckedImagesCount > 0;

  const renderContent = () => {
    if (hasUncheckedImages) {
      return (
        <>
          <HomeImageCount>{uncheckedImagesCount}</HomeImageCount>
          <HomeMessage>изображений осталось проверить</HomeMessage>
          <HomeStartButton onClick={handleStartWork}>Приступить к работе</HomeStartButton>
        </>
      );
    }

    return (
      <>
        <HomeImageCount>🎉</HomeImageCount>
        <HomeMessage>Ура, все изображения проверены!</HomeMessage>
      </>
    );
  };

  return (
    <HomeBlock>
      <HomeLogoutButton onClick={handleLogout}>Log out</HomeLogoutButton>

      <HomeContent>
        <HomeTitle>Проверка изображений</HomeTitle>
        {renderContent()}
      </HomeContent>
    </HomeBlock>
  );
};

export { Home };
